import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./ForgetPassword.css";
import logo_large from "../../assets/Images/logo_login.png";
import { useFormik } from "formik";
import { InputAdornment, TextField, IconButton } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import {
  forgotPassword,
  otpGenerate,
  otpVerify,
  validateLinkPassword,
} from "../../services/authService";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import {
  setisLoginUser,
  setLoader,
  setToken,
  setUserData,
} from "../../redux/features/authSliceandSidebar";
import { common_axios } from "../../App";

const ForgetPassword = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [timer, setTimer] = useState(10);
  const [otpSent, setOtpSent] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showPassword1, setShowPassword1] = useState(false);
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    formik.setFieldValue("otpgen", false);
    formik.setFieldValue("uuid", null);
    if (location.pathname.includes("password")) {
      dispatch(setLoader(true));
      if (location.pathname?.slice(location.pathname.lastIndexOf("/") + 1)) {
        formik.setFieldValue("otpgen", true);
        formik.setFieldValue(
          "uuid",
          location.pathname?.slice(location.pathname.lastIndexOf("/") + 1)
        );
        dispatch(setLoader(false));
      } else {
      }
    }
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const formik = useFormik({
    initialValues: {
      usernameOrEmail: "",
      password: "",
      otp: "",
      otpgen: false,
      password: "",
      confirmPassword: "",
      uuid: "",
    },
    onReset: (initialValues) => ({
      values: { initialValues },
    }),

    onSubmit: async (values) => {
      let formdata = {
        email: values.usernameOrEmail,
      };
      dispatch(setLoader(true));
      forgotPassword(formdata).then((res) => {
        if (res && res.data?.statusDescription?.statusCode == 200) {
          dispatch(setLoader(false));

          toast.success(res.data?.statusDescription?.description);
          formik.setFieldValue("email", "");
        } else {
          toast.error(res.data?.statusDescription?.description);
        }
      });
    },
  });
  useEffect(() => {
    let interval;
    if (formik.values.otpgen && timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    } else if (timer === 0) {
      clearInterval(interval);
      setOtpSent(false);
    }
    return () => clearInterval(interval);
  }, [formik.values.otpgen, timer]);

  const changePassword = async () => {
    let { confirmPassword, password, uuid } = formik.values;

    if (!confirmPassword || !password)
      return toast.warn(
        `${!confirmPassword ? "Confirm Password " : ""}     ${
          !confirmPassword && !password ? " and " : ""
        }     ${!password ? "Password" : ""} field(s)${
          !confirmPassword && !password ? " are " : " is "
        } required`
      );

    if (confirmPassword != password)
      return toast.warn("Confirm password and password must be same");

    let formdata = {
      newPassword: confirmPassword,
      uuid,
    };
    try {
      dispatch(setLoader(true));
      await validateLinkPassword(formdata).then((res) => {
        dispatch(setLoader(false));
        // console.log(res);

        if (res && res.data.statusDescription.statusCode == 200) {
          toast.success(res.data.statusDescription.description);
          navigate("/");
          dispatch(setLoader(false));
        } else {
          toast.error(res.data.statusDescription.description);
          dispatch(setLoader(false));
        }
      });
    } catch (e) {
      // console.log(e);
    }
  };

  const handleChange = (name, value) => {
    if (value.length < 20) return formik.setFieldValue(name, value);
  };

  return (
    <div className="login-container">
      <div className="login-left">
        <div className="login-content">
          <img src={logo_large} alt="Mining Portal" className="login-logo" />
          <h1>Welcome to Mining Portal</h1>
          <p>Enter your credentials to access your account</p>
        </div>
      </div>
      <div className="login-right">
        <div className="login-form-container">
          {location?.pathname?.includes("password") ? (
            <h2>Enter New Password</h2>
          ) : (
            <h2>Forgot Password</h2>
          )}

          <form onSubmit={formik.handleSubmit}>
            {location?.pathname?.includes("password") ? (
              <span>
                <div className="form-group">
                  <div className="form-group pswd_div">
                    <TextField
                      type={showPassword ? "text" : "password"}
                      label="Password"
                      className="position-relative"
                      name="password"
                      value={formik.values.password}
                      onChange={(e) => {
                        handleChange("password", e.target.value);
                      }}
                      placeholder="Enter password"
                      fullWidth
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              title={
                                showPassword ? "hide password" : "show password"
                              }
                              aria-label="toggle password visibility"
                              onClick={(e) => {
                                setShowPassword(!showPassword);
                              }}
                              onMouseDown={handleInputChange}
                            >
                              {showPassword ? (
                                <VisibilityIcon
                                  className="position-absolute eye_icn"
                                  sx={{ color: "#85CBF2" }}
                                />
                              ) : (
                                <VisibilityOffIcon
                                  className="position-absolute eye_icn"
                                  sx={{ color: "#85CBF2" }}
                                />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),

                        startAdornment: (
                          <InputAdornment position="start">
                            <i className="fas fa-lock"></i>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </div>
                </div>
                <div className="form-group">
                  <div className="form-group pswd_div">
                    <TextField
                      type={showPassword1 ? "text" : "password"}
                      label="Confirm Password"
                      className="position-relative"
                      name="confirmPassword"
                      value={formik.values.confirmPassword}
                      onChange={(e) => {
                        handleChange("confirmPassword", e.target.value);
                      }}
                      placeholder="Enter confirm password"
                      fullWidth
                      InputProps={{
                        maxLength: 20,
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              title={
                                showPassword ? "hide password" : "show password"
                              }
                              aria-label="toggle password visibility"
                              onClick={(e) => {
                                setShowPassword1(!showPassword1);
                              }}
                              onMouseDown={handleInputChange}
                            >
                              {showPassword1 ? (
                                <VisibilityIcon
                                  className="position-absolute eye_icn"
                                  sx={{ color: "#85CBF2" }}
                                />
                              ) : (
                                <VisibilityOffIcon
                                  className="position-absolute eye_icn"
                                  sx={{ color: "#85CBF2" }}
                                />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),

                        startAdornment: (
                          <InputAdornment position="start">
                            <i className="fas fa-lock"></i>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </div>
                </div>
                {/* <div className="form-group remember-forgot d-flex justify-content-end">
                  <label className="remember-me" style={{ display: "none" }}>
                    <input type="checkbox" style={{ display: "none" }} />{" "}
                    <span className="remember" style={{ display: "none" }}>
                      Remember me
                    </span>
                  </label>
                  {otpSent ? (
                    <p>{timer}</p>
                  ) : (
                    <a
                      onClick={formik.handleSubmit}
                      className="forgot-password"
                    >
                      Regenerate OTP
                    </a>
                  )}
                </div> */}
                <button
                  type="button"
                  className="login-btn"
                  onClick={(e) => {
                    changePassword();
                  }}
                >
                  Save <i className="fas fa-arrow-right"></i>
                </button>
              </span>
            ) : (
              <span>
                <div className="form-group labl_div">
                  {/* <div className="input-group"> */}
                  <TextField
                    type="email"
                    label="Email"
                    name="usernameOrEmail"
                    value={formik.values.usernameOrEmail}
                    onChange={formik.handleChange}
                    placeholder="Enter your email"
                    fullWidth
                    InputProps={{
                      maxLength: 20,
                      startAdornment: (
                        <InputAdornment position="start">
                          <i
                            className="fas fa-envelope"
                            style={{ color: "#555" }}
                          ></i>
                        </InputAdornment>
                      ),
                    }}
                  />
                  <i className="fas fa-envelope"></i>
                  {/* </div> */}
                </div>
                {/* <div className="form-group pswd_div">
                  <TextField
                    type={showPassword ? "text" : "password"}
                    label="Password"
                    className="position-relative"
                    name="password"
                    value={formik.values.password}
                    onChange={formik.handleChange}
                    placeholder="Enter password"
                    fullWidth
                    InputProps={{
            
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            title={
                              showPassword ? "hide password" : "show password"
                            }
                            aria-label="toggle password visibility"
                            onClick={(e) => {
                              setShowPassword(!showPassword);
                            }}
                            onMouseDown={handleInputChange}
                          >
                            {showPassword ? (
                              <VisibilityIcon
                                className="position-absolute eye_icn"
                                sx={{ color: "#85CBF2" }}
                              />
                            ) : (
                              <VisibilityOffIcon
                                className="position-absolute eye_icn"
                                sx={{ color: "#85CBF2" }}
                              />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),

                      startAdornment: (
                        <InputAdornment position="start">
                          <i className="fas fa-lock"></i>
                        </InputAdornment>
                      ),
                    }}
                  />
                </div> */}

                <div className="form-group remember-forgot text-end">
                  {/* <label className="remember-me">
                    <input type="checkbox" />{" "}
                    <span className="remember">Remember me</span>
                  </label> */}
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/");
                    }}
                    className="forgot-password"
                  >
                    Login
                  </a>
                </div>

                <button type="submit" className="login-btn">
                  Send Mail <i className="fas fa-arrow-right"></i>
                </button>

                {/* <p
                  className="mt-2 text-primary"
                  onClick={(e) => {
                    navigate("/");
                  }}
                >
                  {" "}
                  Login{" "}
                </p> */}
              </span>
            )}
          </form>
        </div>
      </div>
    </div>
  );
};

export default ForgetPassword;
